// NotFound.js
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Box,
  Paper,
} from '@mui/material';
import Footer from './layout/Footer';
import titleIcon from '../assets/images/title.png';

function NotFound() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* シンプルなロゴバー */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 3,
          py: 1.5,
          borderBottom: '1px solid rgba(0,0,0,0.06)',
        }}
      >
        <Box
          component={RouterLink}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            '&:hover': { opacity: 0.7 },
          }}
        >
          <Box
            component="img"
            src={titleIcon}
            alt="AI人事 アイコン"
            sx={{ height: '2.5rem', width: 'auto' }}
          />
        </Box>
      </Box>
      <Container component="main" maxWidth="md" sx={{ flexGrow: 1, mt: 4 }}>
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="h3" gutterBottom>
            404 - ページが見つかりません
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            お探しのページは存在しないか、移動した可能性があります。
          </Typography>
          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              to="/"
            >
              ホームに戻る
            </Button>
          </Box>
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
}

export default NotFound;
